module.exports = __webpack_public_path__ + "img/smartbox_brand_logo.90a31a57.svg";